import { ConstructionTypeBase } from './base/construction-type-base';

export class ConstructionType extends ConstructionTypeBase { }